<!--
 * @Author: liushumin
 * @Date: 2022-09-14 18:05:05
 * @LastEditTime: 2022-10-24 10:21:49
 * @LastEditors: liushumin
-->
<template>
  <el-dialog title="发票信息" :visible.sync="dialogVisible_fp" width="650px" :before-close="handleClose" class="fpDialog">
    <el-form :model="dynamicValFpForm" :rules="fpRules" ref="dynamicValFpForm" class="select-dynamic">
      <el-form-item prop="billTypes" label="发票类型">
        <el-radio-group v-model="dynamicValFpForm.billTypes" @change="selectFpRadio">
          <el-radio label="普通发票">普通发票</el-radio>
          <el-radio label="增值税专用发票">增值税专用发票</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="status" label="抬头类型">
        <el-radio-group v-model="dynamicValFpForm.status" label="抬头类型" @change="selectTRadio">
          <el-radio :label="0">个人</el-radio>
          <el-radio :label="1">单位</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="fpForm">
        <el-form-item prop="billTitle" label="发票抬头">
          <el-input type="text" placeholder="请输入" style="width: 75%" v-model="dynamicValFpForm.billTitle"
            maxlength="50">
          </el-input>
        </el-form-item>
        <div v-if="dynamicValFpForm.status == 0">
          <el-form-item prop="payeeTel" label="收票人手机">
            <el-input type="text" placeholder="请输入" style="width: 75%" v-model="dynamicValFpForm.payeeTel"
              maxlength="11" oninput="value=value.replace(/[^0-9]/g,'')">
            </el-input>
          </el-form-item>
          <el-form-item prop="payeeMailbox" label="收票人邮箱">
            <el-input type="text" placeholder="请输入" style="width: 75%" v-model="dynamicValFpForm.payeeMailbox"
              maxlength="50">
            </el-input>
          </el-form-item>
        </div>
        <div v-if="dynamicValFpForm.status == 1">
          <el-form-item prop="socialCreditCode" label="纳税人识别号">
            <el-input type="text" placeholder="请输入购买方纳税人识别号或统一社会信用代码" style="width: 75%"
              v-model="dynamicValFpForm.socialCreditCode" maxlength="50">
            </el-input>
          </el-form-item>
          <el-form-item prop="address" label="公司地址">
            <el-input type="text" placeholder="请输入" style="width: 75%" v-model="dynamicValFpForm.address"
              maxlength="50">
            </el-input>
          </el-form-item>
          <!-- <el-form-item prop="telephone" label="公司电话">
            <el-input type="text" placeholder="请输入" style="width: 75%" v-model="dynamicValFpForm.telephone"
              maxlength="11" oninput="value=value.replace(/[^0-9]/g,'')">
            </el-input>
          </el-form-item> -->
          <el-form-item prop="telephone" label="公司电话">
            <el-input type="text" placeholder="请输入" style="width: 75%" v-model="dynamicValFpForm.telephone">
            </el-input>
          </el-form-item>
          <el-form-item prop="bankName" label="开户行">
            <el-input type="text" placeholder="请输入" style="width: 75%" v-model="dynamicValFpForm.bankName"
              maxlength="50">
            </el-input>
          </el-form-item>
          <el-form-item prop="accountNum" label="银行账号">
            <el-input type="text" placeholder="请输入" style="width: 75%" oninput="value=value.replace(/[^\d]/g,'')"
              v-model="dynamicValFpForm.accountNum" maxlength="50">
            </el-input>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <!-- <el-button
        type="primary"
        :disabled="stepLoading"
        @click="submitForm('dynamicValFpForm')"
        >确 定</el-button
      > -->
      <el-button type="primary" @click="submitForm('dynamicValFpForm')">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: ["openStatus", "infoFpObj", "orderId"],
  data() {
    const validatePhone = (rule, value, callback) => {
      const mobileReg = /^(([1][3,4,5,7,8]\d{9})|([0]\d{10,11})|(\d{7,8})|(\d{4}|\d{3})-(\d{7,8}))$/;
      const phoneReg = /^\d{3}-\d{8}|\d{4}-\d{7}$/;
      if(!value || value === ""){
        callback(new Error("公司电话不能为空"));
      }else if(value.length == 11){
        if(!mobileReg.test(value)){
          callback(new Error("请输入正确的手机号码或者固话号码（固话格式：区号-号码）"))
        }else{
          callback();
        }
      }else if(value.length == 12){
        if(!phoneReg.test(value)){
          callback(new Error("请输入正确的手机号码或者固话号码（固话格式：区号-号码）"))
        }else{
          callback();
        }
      }else{
          callback(new Error("请输入正确的手机号码或者固话号码（固话格式：区号-号码）"))
      }
    }
    return {
      stepLoading: false,
      dialogVisible_fp: false,
      fpRules: {
        billTypes: {
          required: true,
          message: "发票类型不能为空",
          trigger: "change",
        },
        status: {
          required: true,
          message: "抬头类型不能为空",
          trigger: "change",
        },
        billTitle: {
          required: true,
          message: "发票抬头不能为空",
          trigger: "blur",
        },
        socialCreditCode: {
          required: true,
          message: "纳税人识别号不能为空",
          trigger: "blur",
        },
        address: {
          required: true,
          message: "公司地址不能为空",
          trigger: "blur",
        },
        telephone: {
          required: true,
          // message: "公司电话不能为空",
          trigger: "blur",
          validator: validatePhone,
        },
        bankName: {
          required: true,
          message: "开户行不能为空",
          trigger: "blur",
        },
        accountNum: {
          required: true,
          message: "银行账号不能为空",
          trigger: "blur",
        },
      },
      dynamicValFpForm: {
        billTypes: "",
        status: "",
        id: "",
        billTitle: "",
        payeeTel: "",
        payeeMailbox: "",
        socialCreditCode: "",
        address: "",
        telephone: "",
        bankName: "",
        accountNum: "",
        orderId: "",
      },
    };
  },
  watch: {
    openStatus(val1, val2) {
      this.dialogVisible_fp = this.openStatus;
    },
    "$store.state.szStatus.szFareDetails": {
      deep: true,
      handler(newValue, oldValue) {
        this.dynamicValFpForm = newValue;
      },
    },
  },
  mounted() {
    this.dynamicValFpForm = this.$store.state.szStatus.szFareDetails;
    // this.dynamicValFpForm.billTitle = this.dynamicValFpForm.billTitle;
  },
  methods: {
    submitForm(formName) {
      this.stepLoading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitFpList();
        } else {
          return false;
        }
      });
    },
    selectTRadio(val) {
      this.dynamicValFpForm.status = val;
    },
    selectFpRadio(val) {
      this.dynamicValFpForm.billTypes = val;
    },
    // 修改发票接口
    submitFpList() {
      if (this.dynamicValFpForm.orderId != "") {
        this.stepLoading = true;
        this.$http.szOrder.editInvoice(this.dynamicValFpForm).then((res) => {
          this.stepLoading = false;
          if (res.status == 1) {
            this.dialogVisible_fp = false;
            this.$emit("closeStatus", true);
            this.$message({
              message: "修改成功",
              type: "success",
            });
            setTimeout(() => {
              this.stepLoading = false;
            }, 1000);
          }
        });
      } else {
        this.dialogVisible_fp = false;
        this.$emit("closeStatus", true);
        this.$emit("addSzFp", this.dynamicValFpForm);
      }
    },
    handleClose() {
      this.dialogVisible_fp = false;
      this.$emit("closeStatus", true);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../../../styles/order-global.scss';
</style>